import { render, staticRenderFns } from "./editAppointmentHour.vue?vue&type=template&id=146579fe&scoped=true"
import script from "./editAppointmentHour.vue?vue&type=script&lang=js"
export * from "./editAppointmentHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146579fe",
  null
  
)

export default component.exports